module.exports = __webpack_public_path__ + "static/media/icn-delete-24px-grey.a746ff0d.svg";